<template>
    <v-card flat class="score-trans ma-1">
        <v-container fluid>
            <v-row dense>
                <v-col cols="6">
                    <v-card flat class="score-trans">
                        <v-container fluid>
                            <h3>Week {{ $moment(new Date()).isoWeek() }}</h3>    
                            <div>{{ $moment(new Date()).format("dddd, MMMM Do YYYY") }}</div>
                        </v-container>
                    </v-card>    
                </v-col>
                <v-col cols="6" span="5">   
                    <left_panel_reviews_summary ref="leftpanelreviewsummary"/>
                </v-col>
            </v-row>        
            <v-row>
                <v-col cols="12">
                    <left_panel_performance_table_wrapper ref="leftpanelperformance"/>
                </v-col>  
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

   import left_panel_reviews_summary from '@/components/dashboard/sections/left_panel_reviews_summary.vue';
   import left_panel_performance_table_wrapper from '@/components/dashboard/sections/left_panel_performance_table_wrapper.vue';

    export default {    
        components: {
            left_panel_reviews_summary,
            left_panel_performance_table_wrapper,
        },
        methods: {       
            load(){ 
                console.log('(re) load left panel header');
                this.$refs.leftpanelperformance.load();
            },       
       }    
    }
</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
</style>